<template>
  <div class="app-main-inner">
    <div class="app-main-top">
      <div class="app-main-top-half fl">
        <h1>Balance</h1>
        <div class="payment-btn" @click="openMsgDialog">Withdraw</div>
        <div class="payment-info">
          <div class="payment-money" v-if="balance">${{balance}}</div>
          <div class="payment-money" v-else>$0.00</div>
        </div>
      </div>
      <div class="app-main-top-half fr">
        <h1>Info</h1>
        <router-link to="paymentInfo" tag="div" class="payment-btn">Edit</router-link>
        <div class="payment-info">
          <p><span>Name:</span>{{paymentInfo.firstName}} {{paymentInfo.middleInitial}} {{paymentInfo.lastName}}</p>
          <p><span>Phone:</span>{{paymentInfo.phone}}</p>
          <p><span>Address:</span>{{paymentInfo.addressLine1}}</p>
        </div>
      </div>
    </div>
    <div class="app-main-middle">
       <div class="payment-box">
          <div class="payment-box-top">
            <h1>Bills Detail</h1>
            <router-link to="paymentList" tag="a" class="payment-btn fr">more</router-link>
          </div>
          <div class="payment-box-innner">
            <div class="table-payment">
              <el-table
                :data="paymentData"
                :highlight-current-row="false"
                style="width: 100%">
                <el-table-column
                  prop="name"
                  label="Name"
                  align="center">
                  <template slot-scope="scope" v-if="paymentData.length>0">
                    <div v-if="scope.row.financeRecord.type===1">
                      Withdraw
                    </div>
                    <div v-else>
                      {{scope.row.name}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="amount"
                  label="Amount"
                  align="center">
                  <template slot-scope="scope" v-if="paymentData.length>0">
                    <div v-if="scope.row.financeRecord.type===1">
                      - {{scope.row.financeRecord.amount}} $
                    </div>
                    <div v-else>
                      + {{scope.row.financeRecord.amount}} $
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="time"
                  label="Time"
                  align="center">
                  <template slot-scope="scope" v-if="paymentData.length>0">
                    {{$utils.formatTime(scope.row.financeRecord.createdAt)}}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="status"
                  label="Status"
                  align="center">
                  <template slot-scope="scope" v-if="paymentData.length>0">
                    <div v-if="scope.row.financeRecord.status===0">
                      Waiting for Payment
                    </div>
                    <div v-else-if="scope.row.financeRecord.status===1" class="payment-status-success">
                      Success
                    </div>
                    <div v-else class="payment-status-error" @click="openWhyDialog(scope.row.financeRecord.reason)">
                      Fail(see why?)
                    </div>
                  </template>
                </el-table-column>
              </el-table>     
            </div>
          </div>
       </div>
    </div>
    <div class="box dialog-box" v-bind:class="{ fade: isMsgfade}">
      <div class="box-inner">
        <div class="dialog-info">
          <div class="title">Withdraw</div>
          <div class="wthdraw-top">
            <span class="wthdraw-title">Withdraw Type：</span>
            <div class="wthdraw-radio">
                <el-radio-group v-model="payChannel">
                  <div class="wthdraw-radio-group">
                    <el-radio label="1" v-if="bankInfoStatus!==0">Check</el-radio>
                    <el-radio label="1" v-else disabled>Check</el-radio>
                  </div>
                  <div class="wthdraw-radio-group">
                    <el-radio label="0" v-if="bankInfoStatus===2">Bank Transfer</el-radio>
                    <el-radio label="0" v-else disabled>Bank Transfer</el-radio>
                    <div class="wthdraw-btn" v-show="bankInfoStatus!==2" style="position: relative;top: -7px;" @click="improveInformation">Improve information</div>
                  </div>
                </el-radio-group>   
                <p class="wthdraw-tip">You must improve the withdrawal information to be able to use bank transfer</p>           
            </div>
          </div>
          <div class="wthdraw-bottom">
            <span class="wthdraw-title">Amount：</span>
            <div class="form-group text-align-left">
              <input type="text" v-model.number="amount">
            </div>
            <div class="wthdraw-val">
              <span v-if="balance">Current Balance：${{balance}}</span>
              <span v-else>Current Balance：$0.00</span>
              <div class="wthdraw-btn" v-if="balance" @click="allWithdrawals">All Withdrawals</div>
            </div>
          </div>
          <div class="form-group">
            <a class="btn-cancel fl" @click="closeMsgDialog">cancel</a>
            <a class="btn-ok fr" @click="applyWithdraw">Submit</a>
          </div>
        </div>
      </div>
    </div>
    <div class="box dialog-box" v-bind:class="{ fade: isWhyfade}">
      <div class="box-inner">
        <div class="dialog-info">
          <div class="dialog-close-btn" @click="closeWhyDialog"></div>
          <div class="title">Why did it fail</div>
          <div class="message">{{why}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from "components/app-header/app-header";
import AppSilder from "components/app-silder/app-silder";
import { ERR_OK } from "api/config";
import {
  getBankInfoStatus,
  getFinanceRecords,
  getBankInfo,
  applyWithdraw
} from "api/payment";
export default {
  data() {
    return {
      paymentData: [],
      paymentInfo: {
        name: "",
        phone: "",
        address: ""
      },
      isMsgfade: false,
      isWhyfade: false,
      why: "",
      payChannel: "1",
      amount: "",
      financeRecordsParam: {
        pageNumber: 1,
        pageSize: 10
      },
      bankInfoStatus: 0,
      balance: ""
    };
  },
  components: {
    AppHeader,
    AppSilder
  },
  created() {
    this._getBankInfoStatus();
    this._getFinanceRecords();
    this._getBankInfo();
  },
  methods: {
    _getBankInfoStatus() {
      getBankInfoStatus()
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              let bankInfoStatus = (this.bankInfoStatus =
                response.data.data.status);
              if (bankInfoStatus === 0) {
                this.$router.push({
                  path: "/payment/paymentInfo"
                });
              }
              this.balance = response.data.data.balance
                ? parseFloat(response.data.data.balance).toFixed(2)
                : "0.00";
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    _getFinanceRecords() {
      getFinanceRecords(this.financeRecordsParam)
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.paymentData = response.data.data.content;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    _getBankInfo() {
      getBankInfo()
        .then(response => {
          if (response.status !== 200) {
            this.$message.error(response.data.message);
          } else {
            if (response.data.code === ERR_OK) {
              this.paymentInfo = response.data.data;
            } else {
              this.$message.error(response.data.message);
            }
          }
        })
        .catch(e => {
          this.$message.error(e.message);
        });
    },
    applyWithdraw() {
      let amount = this.amount;
      if (amount && typeof amount === "number" && amount > 0) {
        amount = parseFloat(this.amount).toFixed(2);
      } else {
        this.$message.error("Please enter the present amount");
        return false;
      }
      let payChannel = parseInt(this.payChannel);
      let applyWithdrawParam = {
        payChannel,
        amount
      };
      if (amount) {
        applyWithdraw(applyWithdrawParam)
          .then(response => {
            if (response.status !== 200) {
              this.$message.error(response.data.message);
            } else {
              if (response.data.code === ERR_OK) {
                this.closeMsgDialog();
                this.$message.success("Application for success");
                this._getFinanceRecords();
                let balance = this.balance;
                this.balance = parseFloat(
                  balance - response.data.data.amount
                ).toFixed(2);
              } else {
                this.$message.error(response.data.message);
              }
            }
          })
          .catch(e => {
            this.$message.error(e.message);
          });
      } else {
        this.$message.error("Please enter the present amount");
      }
    },
    allWithdrawals() {
      this.amount = parseFloat(this.balance);
    },
    improveInformation() {
      this.closeMsgDialog();
      this.$router.push({
        path: "/payment/paymentInfo",
        query: {
          step: 2
        }
      });
    },
    openMsgDialog() {
      if (this.balance >= 20) {
        this.isMsgfade = true;
        document.body.setAttribute("class", "dialogfade");
      } else {
        this.$message.error("Balance must be higher than $20 to withdraw cash");
      }
    },
    closeMsgDialog() {
      this.isMsgfade = false;
      this.amount = "";
      document.body.removeAttribute("class", "dialogfade");
    },
    openWhyDialog(why) {
      this.isWhyfade = true;
      this.why = why;
      document.body.setAttribute("class", "dialogfade");
    },
    closeWhyDialog() {
      this.isWhyfade = false;
      document.body.removeAttribute("class", "dialogfade");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~styles/variables.scss";
@import "~styles/mixin.scss";
.app-main-inner {
  background: transparent;
  border: 0px;
  .app-main-top {
    height: auto;
    line-height: inherit;
    border-bottom: 0;
    padding: 0;
    @include clearfix;
    .app-main-top-half {
      width: 438px;
      height: 138px;
      background-color: #fff;
      border: 1px solid #ebebeb;
      padding: 20px;
      border-radius: 5px;
      position: relative;
      h1 {
        font-size: 20px;
        margin: 0;
        line-height: 20px;
      }
      .payment-btn {
        min-width: 75px;
        padding: 0px 10px;
        height: 26px;
        line-height: 26px;
        border: 1px solid #ffa438;
        background: rgba(255, 164, 56, 0.5);
        color: #fff;
        text-align: center;
        border-radius: 20px;
        cursor: pointer;
        position: absolute;
        top: 20px;
        right: 20px;
        z-index: 1;
        font-size: 14px;
      }
      .payment-info {
        .payment-money {
          font-size: 50px;
          line-height: 130px;
          color: #ffa438;
        }
        p {
          margin: 20px 0px 20px;
          padding-left: 80px;
          position: relative;
          font-size: 15px;
          @include ellipsis;
          span {
            position: absolute;
            left: 0;
            top: 0;
          }
        }
      }
    }
  }
  .app-main-middle {
    padding: 20px 0px;
    .payment-box {
      .payment-box-top {
        height: 32px;
        line-height: 32px;
        margin-bottom: 20px;
        h1 {
          display: inline-block;
          float: left;
          font-size: 20px;
          color: #333333;
          margin: 0px 30px 0px 30px;
        }
        .payment-btn {
          display: inline-block;
          background: rgba(255, 164, 56, 0.5);
          border: 1px solid #ffa438;
          border-radius: 20px;
          color: #fff;
          width: 75px;
          height: 32px;
          line-height: 32px;
          text-align: center;
          font-size: 14px;
        }
      }
    }
  }
}
.btn-cancel {
  display: inline-block;
  padding: 7px 50px;
  color: $white;
  text-align: center;
  cursor: pointer;
  border-radius: 20px;
  background: #ccc;
  box-shadow: 2px 3px 0 0 #b1b1b1;
  font-size: 15px;
  border: 1px solid #ccc;
  &:hover {
    background-color: $white;
    color: #ccc;
  }
}
.btn-ok {
  display: inline-block;
  padding: 7px 50px;
  color: $white;
  text-align: center;
  cursor: pointer;
  border-radius: 20px;
  background: $baseColor;
  box-shadow: 2px 3px 0 0 #ca730c;
  font-size: 15px;
  border: 1px solid $baseColor;
  &:hover {
    background-color: $white;
    color: $baseColor;
  }
}
.wthdraw-top {
  border-bottom: 1px solid #ededed;
}
.wthdraw-bottom {
  margin: 20px 0px;
  .form-group {
    margin-bottom: 10px;
    height: 26px;
    line-height: 26px;
    input {
      display: block;
      width: 100%;
      height: 100%;
      border: 0;
      background-color: #f5f5f5;
      border-radius: 20px;
      outline: none;
      text-indent: 20px;
      color: #bebebe;
    }
  }
}
.wthdraw-top,
.wthdraw-bottom {
  position: relative;
  padding-left: 110px;
  padding-bottom: 20px;
  .wthdraw-title {
    position: absolute;
    top: 0;
    left: 0;
    font-size: 15px;
  }
}
.wthdraw-radio {
  text-align: left;
  .wthdraw-radio-group {
    position: relative;
    margin: 5px 0px 15px;
    width: 280px;
  }
  .wthdraw-tip {
    margin: 0;
    color: #ff6868;
    font-size: 14px;
  }
}
.wthdraw-val {
  text-align: left;
  height: 28px;
  line-height: 28px;
  margin-top: 20px;
  span {
    font-size: 14px;
    color: #a8a8a8;
  }
}
.wthdraw-btn {
  display: inline-block;
  background: rgba(255, 164, 56, 0.5);
  border: 1px solid #ffa438;
  border-radius: 20px;
  color: #fff;
  padding: 0px 10px;
  height: 26px;
  line-height: 26px;
  text-align: center;
  font-size: 12px;
  float: right;
  cursor: pointer;
}
.payment-status-success {
  color: #ffa438;
}
.payment-status-error {
  cursor: pointer;
  color: #ff6868;
}
</style>




// WEBPACK FOOTER //
// src/views/payment/payment.vue